<template>
  <v-container>
    <v-card flat class="pa-4">
      <v-row align="center" justify="space-between" no-gutters>
        <v-col cols="12" md="8">
          <h2 class="mb-2">
            {{ $t($ts.settings.giftCardsOptions.title) }}
          </h2>
          <p class="mb-0 text--secondary">
            {{ $t($ts.settings.giftCardsOptions.description) }}
          </p>
        </v-col>
        <v-col
          cols="12"
          md="4"
          class="d-flex justify-md-end align-center mt-4 mt-md-0"
        >
          <v-switch
            v-model="localUseGiftCards"
            color="#56dcb6"
            inset
            :label="booleanToOnOff(localUseGiftCards)"
            :loading="isSaving"
            :disabled="isSaving"
            @change="handleToggle"
          />
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script lang="ts">
import { Component, Vue, Watch } from "vue-property-decorator";
import { userModule } from "@/store/modules/user/userModule";

@Component({
  name: "GiftCardOptionsSettings",
})
export default class GiftCardOptionsSettings extends Vue {
  public localUseGiftCards = userModule.user?.useGiftCards ?? false;
  public isSaving = false;

  get user() {
    return userModule.user;
  }

  @Watch("user.useGiftCards", { immediate: false })
  onUserSettingChanged(newValue?: boolean) {
    this.localUseGiftCards = newValue ?? false;
  }

  booleanToOnOff(value: boolean): string {
    return value ? this.$t(this.$ts.boolean.yes).toString() : this.$t(this.$ts.boolean.no).toString();
  }

  async handleToggle(value: boolean): Promise<void> {
    if (this.isSaving) return;
    this.isSaving = true;
    try {
      await userModule.updateUser({ useGiftCards: value });
    } catch (error) {
      console.error(error);
      this.localUseGiftCards = this.user?.useGiftCards ?? false;
    } finally {
      this.isSaving = false;
    }
  }
}
</script>

<style scoped></style>
